import { HotelLoyaltyMap } from "redmond";

export interface IHotelLoyalty {
  key: string;
  value: string;
  trackingId: number;
  error: boolean;
}

export type IHotelLoyaltyList = IHotelLoyalty[];

// Validates strictly alphanumeric values (for IDs, loyalty program codes, etc.)
export const strictAlphanumericRegex = /^[a-zA-Z0-9]+$/;
// Validates passport numbers, frequent flyer numbers (allows slashes and dashes)
export const codeRegex = /^[a-zA-Z0-9 /-]+$/;
// Validates loyalty number, loyalty email (can be used for frequent flyer field too)
export const loyaltyPattern = /^[a-zA-Z0-9 /@._+-]+$/;

export const getHotelLoyaltyList = (
  hotelLoyaltyMap: HotelLoyaltyMap
): IHotelLoyaltyList =>
  Object.entries(hotelLoyaltyMap).map((hotelLoyalty, index) => ({
    key: hotelLoyalty[0],
    value: hotelLoyalty[1].value,
    trackingId: index,
    error: !(
      strictAlphanumericRegex.test(hotelLoyalty[0]) &&
      loyaltyPattern.test(hotelLoyalty[1].value)
    ),
  }));

export const getHotelLoyaltyMap = (
  hotelLoyaltyList: IHotelLoyaltyList
): HotelLoyaltyMap => {
  const hotelLoyaltyMap: HotelLoyaltyMap = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const hotelLoyalty of hotelLoyaltyList) {
    hotelLoyaltyMap[hotelLoyalty.key] = {
      value: hotelLoyalty.value,
    };
  }

  return hotelLoyaltyMap;
};
